import React from 'react';

const AuthorBox = ({ singlePost }) => {
  return (
    <div className="border p-4 mt-4 rounded-md bg-light text-dark d-flex align-items-center gap-3">
      <div>
        <img
          src={singlePost.author_image?.url || "/images/chat.png"}
          alt="Author"
          style={{ width: '100px', height: '100px', borderRadius: '50%' }}
        />
      </div>
      <div>
        <h4>{singlePost?.author?.name}</h4>
        <p>{singlePost?.author_description}</p>
      </div>
    </div>
  );
};

export default AuthorBox;
